
import React from "react";
import SalesFunnelsModule from "@/components/admin/sales-funnels/SalesFunnelsModule";

const SalesFunnelsManagement: React.FC = () => {
  return <SalesFunnelsModule />;
};

export default SalesFunnelsManagement;
